import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-p-2 inherit-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Regex = _resolveComponent("Regex")!
  const _component_DialogDelete = _resolveComponent("DialogDelete")!
  const _component_RegexForm = _resolveComponent("RegexForm")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_EntryDialog = _resolveComponent("EntryDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Regex, {
        regexes: _ctx.regexes,
        loading: _ctx.loading,
        showErrorMessage: _ctx.showValidationMessage,
        showSingleLinedForm: _ctx.showSingleLinedForm,
        onOnClickDelete: _ctx.openDeleteDialog,
        onOnEntrySelect: _ctx.onEntrySelect,
        onOnChangeRegex: _ctx.onChangeRegex
      }, null, 8, ["regexes", "loading", "showErrorMessage", "showSingleLinedForm", "onOnClickDelete", "onOnEntrySelect", "onOnChangeRegex"])
    ]),
    _createVNode(_component_DialogDelete, {
      showDialog: _ctx.deleteDialog,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.deleteDialog = false)),
      onOnConfirm: _ctx.deleteEntry
    }, null, 8, ["showDialog", "onOnConfirm"]),
    _createVNode(_component_EntryDialog, {
      show: _ctx.showDialog,
      onOnClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDialog = false, _ctx.isValidationInvalid = true, _ctx.showValidationMessage = false)),
      onOnConfirm: _ctx.saveRegex,
      loading: _ctx.loadingDialog,
      headerText: _ctx.headerText,
      showKeepDialogOpen: !_ctx.regex.id
    }, {
      content: _withCtx(() => [
        _createVNode(_component_BlockUI, { blocked: _ctx.loadingDialog }, {
          default: _withCtx(() => [
            _createVNode(_component_RegexForm, {
              ref: "regexForm",
              regex: _ctx.regex,
              onUpdate: _ctx.onUpdate,
              showErrorMessage: _ctx.showValidationMessage
            }, null, 8, ["regex", "onUpdate", "showErrorMessage"])
          ]),
          _: 1
        }, 8, ["blocked"])
      ]),
      _: 1
    }, 8, ["show", "onOnConfirm", "loading", "headerText", "showKeepDialogOpen"])
  ], 64))
}